import React from "react";

export default function SectionCard({ title, children }) {
    return (
        <div style={{ marginBottom: 36 }}>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                    zIndex: 1,
                    padding: "0 8px"
                }}
            >
                <span
                    style={{
                        whiteSpace: "normal",
                        fontWeight: "bold",
                        fontSize: 16,
                        color: "rgba(0,0,0,0.85)",
                        padding: "0 8px",
                        backgroundColor: "#fff"
                    }}
                >
                    {title}
                </span>
            </div>

            <div
                style={{
                    border: "1px solid #e8e8e8",
                    borderRadius: 8,
                    padding: "16px 16px 0px 16px",
                    marginTop: -12
                }}
            >
                {children}
            </div>
        </div>
    );
}
